export const setJustifications = (listJustification) => {
    return {
        type: 'LIST_JUSTIFICATION',
        listJustification,
    };
};

export const setJustification = (justification) => {
    return {
        type: 'SET_JUSTIFICATION',
        justification
    };
};

export const resetFilters = () => {
    return {
        type: 'RESET_FILTER',
    };
};

export const setJustificationsType = (listJustificationType) => {
    return {
        type: 'LIST_JUSTIFICATION_TYPE',
        listJustificationType,
    };
};